var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"checkbox-group"},_vm._l((_vm.countryList),function(country,index){return _c('el-checkbox',{key:index,staticClass:"checkbox-item",attrs:{"label":country.label}},[_c('span',[_vm._v(_vm._s(country.label))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }